import { getType } from 'typesafe-actions';
import { Logger } from '../Logger/Logger';
var WindowMessenger = /** @class */ (function () {
    function WindowMessenger(targetWindow, logger) {
        if (logger === void 0) { logger = new Logger('WindowMessenger'); }
        this.handlerDescriptions = [];
        this.logger = logger;
        this.targetWindow = targetWindow;
        window.addEventListener('message', this.handleMessage.bind(this), false);
    }
    WindowMessenger.prototype.setTarget = function (target) {
        this.targetWindow = target;
    };
    WindowMessenger.prototype.on = function (actionCreator, handler, once) {
        var _this = this;
        if (once === void 0) { once = false; }
        this.handlerDescriptions.push({
            actionCreator: actionCreator,
            handler: handler,
            once: once,
        });
        return function () {
            _this.off(actionCreator, handler);
        };
    };
    WindowMessenger.prototype.once = function (actionCreator, handler) {
        return this.on(actionCreator, handler, true);
    };
    WindowMessenger.prototype.off = function (actionCreator, handler) {
        this.handlerDescriptions = this.handlerDescriptions.filter(function (desc) {
            return !(desc.actionCreator === actionCreator &&
                (desc.handler === handler || !handler));
        });
    };
    WindowMessenger.prototype.emit = function (action) {
        this.logger.log('postMessage emitted', action);
        if (!this.targetWindow) {
            throw new Error('target window should be defined');
        }
        this.targetWindow.postMessage(action, '*');
    };
    WindowMessenger.prototype.offAll = function () {
        this.handlerDescriptions = [];
    };
    WindowMessenger.prototype.handleMessage = function (windowEvent) {
        if (windowEvent.source !== this.targetWindow) {
            return;
        }
        var action = this.parseMessageData(windowEvent.data);
        if (!action) {
            return;
        }
        this.logger.log('postMessage received', action);
        this.handlerDescriptions
            .filter(function (observer) { return getType(observer.actionCreator) === action.type; })
            .forEach(this.runObserver(action));
    };
    WindowMessenger.prototype.runObserver = function (action) {
        var _this = this;
        return function (handlerDescription) {
            handlerDescription.handler.call(_this, action);
            if (handlerDescription.once) {
                _this.off(handlerDescription.actionCreator, handlerDescription.handler);
            }
        };
    };
    WindowMessenger.prototype.parseMessageData = function (input) {
        if (input === void 0) { input = {}; }
        var type = input.type, payload = input.payload;
        if (!type || typeof type !== 'string') {
            return;
        }
        return { type: type, payload: payload };
    };
    return WindowMessenger;
}());
export { WindowMessenger };
//# sourceMappingURL=WindowMessenger.js.map